// extracted by mini-css-extract-plugin
export default {"buttons":"styles_buttons__C28xD","stakeButton":"styles_stakeButton__sFMaU","purchaseButton":"styles_purchaseButton__wory5","appear":"styles_appear__hkwhI"};